import { reducerWithInitialState } from "typescript-fsa-reducers";
import { bootstrapped, CurrentUser, CurrentCompany, Country } from "../actions/Auth";

export interface AuthState {
  currentUser: CurrentUser | null;
  currentCompany: CurrentCompany | null;
  country: Country;
  locale: string;
}

const initialState: AuthState = {
  currentUser: null,
  currentCompany: null,
  country: "",
  locale: "",
};

const authReducer = reducerWithInitialState(initialState).case(bootstrapped, (state, data) => {
  return {
    ...state,
    currentUser: data.current_user,
    currentCompany: data.current_company,
    country: data.current_country,
    locale: data.locale,
  };
});

export default authReducer;



// WEBPACK FOOTER //
// ./frontend/src/common/reducers/auth.ts